<template>
  <div class="container py-5" v-if="product">
    <div class="row">
      <div class="col-md-3">
        <img :src="product.image ? domain + product.image : defaultImage"
         class="img-fluid"
          alt="商品圖片"
          style="max-width: 100%; height: 300px; object-fit: contain;"
          >
      </div>
      <div class="col-md-7">
        <h2>{{ product.nameCH }} <small>({{ product.nameEN }})</small></h2>
        <p><strong>商品編號：</strong>{{ product.code }}</p>
        <p><strong>尺寸：</strong>{{ product.dimension }}</p>
        <p><strong>材質：</strong>{{ product.material }}</p>
        <p><strong>建議售價：</strong>${{ product.suggestedRetailPrice }}</p>
        <p><strong>包裝數量：</strong>{{ product.qntPerPack }} / 箱：{{ product.qntPerCarton }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api' // ✅ 改用共用 API 實例

export default {
  name: 'ProductPage',
  data() {
    return {
      product: null,
      defaultImage: process.env.VUE_APP_API_BASE + "/amigurumi/pic/image-placeholder_640.png",
      domain : process.env.VUE_APP_API_BASE
    };
  },
  async created() {
    const id = this.$route.params.id;
    try {
      const res = await api.get(`/api/Product/GetProductDetailById?id=${id}`);
      this.product = await res.data;
    } catch (err) {
      console.error('商品載入失敗:', err);
    }
  }
};
</script>
